// Pano yeni bir adrese taşınıyor (kioskMove.nl.ts). Türkçe sürüm.
export const kioskMoveTr = {
    title: 'Pano taşınıyor',
    body: 'Aile panosunun yeni bir adresi var: {host}. Pano şimdi kendiliğinden oraya geçiyor ve bağlı kalıyor.',
    askBody: 'Aile panosunun yeni bir adresi var: {host}. Devam’a dokun: Safari panoyu orada, hâlâ bağlı olarak açar. Ardından panoyu ana ekrana nasıl yeniden ekleyeceğini anlatıyoruz.',
    askBodyUnpaired: 'Aile panosunun yeni bir adresi var: {host}. Orada açmak ve bağlamak için Devam’a dokun.',
    button: 'Devam',
    later: 'Sonra',
    failed: 'Taşıma şu anda olmuyor. Pano birazdan yeniden deneyecek.',
    homeTitle: 'Panoyu ana ekrana yeniden ekle',
    homeBody: 'Pano artık {host} adresinde. Safari’de Paylaş’a, sonra “Ana Ekrana Ekle”ye dokun. Ardından panoyu hemen yeni simgeden aç ve eski simgeyi sil. Yeni simge bir kod isterse panoyu uygulamada yeniden bağla. Sonra Safari’deki bu açıklamayı kapat.',
    invalid: 'Bu taşıma kodunun süresi dolmuş ya da kod zaten kullanılmış. Panoyu bu ekrandaki kodla yeniden bağla.',
    offline: 'Bağlantı yok, bu yüzden taşıma olmadı. Panoyu bu ekrandaki kodla yeniden bağla.',
    /** De ouderapp heeft deze tablet losgekoppeld (koppelscherm). */
    revoked: 'Ebeveyn uygulamasında bağlantı kesildi.',
};
//# sourceMappingURL=kioskMove.tr.js.map